<template>
  <TariffTileHorizontal v-if="customerValid"
    :showTariffSelect="true"
    :showPriceStarts="false"
    :quickSelectionBrand="quickSelectionBrand"
    :normalPrice = "promoBenefits.price"
    :promoPrice = "promoBenefits.promoPrice"
    :additionalPriceStairways = "promoBenefits.additionalPriceStairways"
    :startingBonus = "promoBenefits.startingBonus"
    :targetTariff = "targetTariff"
    :targetPromotions = "targetPromotions"
    :exclude-promotion-ids="kwkPromotionIds"
    cta-link="/bestellung"
  >
  <template v-for="slot in possibleChildSlotsFor('TariffTile')" v-slot:[`${slot.child}`]>
    <slot :name="`${slot.parent}`"></slot>
  </template>
  </TariffTileHorizontal>
  <div class="cards-wrapper" v-else><div class="card card-select" style="min-height: 650px;"></div></div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'
import TariffTileHorizontal from '@/components/checkout/tarifftile/generic/TariffTileHorizontal.vue'

export default {
  name: 'KWKTariffTileWrapper',
  data () {
    return {
      kwkToken: null,
      customerValid: false
    }
  },
  components: {
    TariffTileHorizontal
  },
  mixins: [
    trackingHandler
  ],
  created () {
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.has('kwktoken')) {
      window.location.href = '/'
    }
    this.kwkToken = urlParams.get('kwktoken')
    this.resetCompleteCheckoutStore().then(() => {
      const prefetchData = window.$gqlpre
      this.savePresaleInclusive({
        prefetchData: prefetchData.inclusiveAvailablePresalesPromotions !== null ? prefetchData.inclusiveAvailablePresalesPromotions : [],
        force: true
      })
      this.savePresaleBookable({
        prefetchData: prefetchData.bookableAvailablePresalesPromotions !== null ? prefetchData.bookableAvailablePresalesPromotions : [],
        force: true
      })
    })
    this.$store.dispatch('checkoutv2/ordering/resetState')
    this.setKwkToken(this.kwkToken)
    this.hideKwkToken()
    this.startLoader()

    this.queryCart({}).then(async () => {
      await this.loadDefaultTariff()
      await this.setSelectedTariff(this.targetTariff)
      this.customerValid = true
      this.stopLoader()
    }).catch((error) => {
      this.setValidationError(this.getErrorMessage(error))
      this.setValidationErrorCode(this.getErrorCode(error))
      this.stopLoader()
      window.location.href = '/'
    })
  },
  watch: {
    selectedTariffOptionIds: function (v) {
      this.startLoader()

      this.queryCart({}).then((status) => {
        if (!status) {
          this.setValidationError(this.beErrorGetLastMessage())
          this.setValidationErrorCode(this.beErrorGetLastErrorCode())
          window.location.href = '/'
          this.stopLoader()
          return
        }
        this.stopLoader()
      }).catch(() => {
        this.stopLoader()
      })
    }
  },
  computed: {
    ...mapGetters('checkoutv2/ordering/_cart', ['targetTariff', 'targetPromotions', 'selectedTariffOptionIds', 'promoBenefits']),
    kwkPromotionIds () {
      return window.$feconfig?.promotion?.kwkIds || []
    }
  },
  props: {
    quickSelectionBrand: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions('checkout', ['resetCompleteCheckoutStore']),
    ...mapActions('checkout/tariff', ['loadDefaultTariff', 'setSelectedTariff']),
    ...mapMutations('kwk', ['setValidationError', 'setValidationErrorCode']), // error handling on Startseite
    ...mapMutations('promotion', ['savePresaleInclusive', 'savePresaleBookable']),
    ...mapActions('checkoutv2/ordering/_cart', ['queryCart']),
    ...mapMutations('checkoutv2/ordering/_cart', ['setKwkToken', 'setSelectedTariffoptionIds', 'hideKwkToken'])
  }
}
</script>
